import React from 'react';
import { Grid, GridItem, Flex, Text, Container } from '@chakra-ui/react';
import StatGridItem from './StatGridItem';
import { Divider } from '../Divider';

function StatGrid({ data }) {
  const { items, title, subtitle } = data || {};
  return (
    <Container maxW='container.xl' direction='column' alignItems='flex-start'>
      <Divider />
      {title && (
        <Flex direction='column' color='black' gap={10} mb={30}>
          <Text fontSize='4xl' fontWeight={700} lineHeight='1' letterSpacing='-0.03em'>
            {title}
          </Text>
          {subtitle && (
            <Text fontSize='md' fontWeight={600} lineHeight={1.1} mb={2}>
              {subtitle}
            </Text>
          )}
        </Flex>
      )}
      <Grid
        templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }}
        gap={30}
        alignItems='stretch'
      >
        {items.map((item) => (
          <GridItem key={item._key}>
            <StatGridItem item={item} />
          </GridItem>
        ))}
      </Grid>
    </Container>
  );
}

export default StatGrid;
